/* eslint-disable */
import { clone, isEmpty, isNil } from 'ramda';

const isNilEmpty = <T>(v: T) => isNil(v) || isEmpty(v);
const _emptyStringToNull = (o: any) => {
  const src = Object.keys(o);
  for (let i = src.length - 1; i >= 0; i--) {
    const k = src[i];

    if (!isNilEmpty(o[k]) && typeof o[k] === 'object') {
      _emptyStringToNull(o[k]);
    } else if (o[k] === '') {
      o[k] = null;
    }
  }

  return o;
};

export const emptyStringToNull = (o: any) => _emptyStringToNull(clone(o));
